module.exports = __webpack_public_path__ + "images/insta.jpg";


//////////////////
// WEBPACK FOOTER
// ./vively/images/social-media-icons/insta.jpg
// module id = 873
// module chunks = 3